<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">External Links</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[13px] mb-[13px] last:border-none last:mb-0 last:pb-0"
      >
        <div
          class="relative ltr:pl-[28px] rtl:pr-[28px] font-medium text-primary-500"
        >
          <img
            src="@/assets/images/icons/google3.svg"
            class="w-[18px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
            alt="google"
          />
          Google Ad Analytics
        </div>
        <a
          href="#"
          target="_blank"
          class="inline-block transition-all leading-none hover:text-primary-500"
        >
          <i class="material-symbols-outlined !text-[18px]"> open_in_new </i>
        </a>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[13px] mb-[13px] last:border-none last:mb-0 last:pb-0"
      >
        <div
          class="relative ltr:pl-[28px] rtl:pr-[28px] font-medium text-primary-500"
        >
          <img
            src="@/assets/images/icons/instagram2.svg"
            class="w-[18px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
            alt="instagram"
          />
          Instagram Ads
        </div>
        <a
          href="#"
          target="_blank"
          class="inline-block transition-all leading-none hover:text-primary-500"
        >
          <i class="material-symbols-outlined !text-[18px]"> open_in_new </i>
        </a>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[13px] mb-[13px] last:border-none last:mb-0 last:pb-0"
      >
        <div
          class="relative ltr:pl-[28px] rtl:pr-[28px] font-medium text-primary-500"
        >
          <img
            src="@/assets/images/icons/facebook3.svg"
            class="w-[18px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
            alt="facebook"
          />
          Facebook Ads
        </div>
        <a
          href="#"
          target="_blank"
          class="inline-block transition-all leading-none hover:text-primary-500"
        >
          <i class="material-symbols-outlined !text-[18px]"> open_in_new </i>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ExternalLinks",
});
</script>
